import { useTheme } from "@mui/material/styles";
import type { FC } from "react";
import { ASSISTANT_AVATAR } from "../../../../../theme/tokens";
import { pxToArtUnits } from "../../assistantAvatarGeometry";

const { BADGE } = ASSISTANT_AVATAR;
// Top-right of the figure, where the count sits clear of the face in both styles.
const BADGE_CENTER = { x: 102, y: 16 } as const;

interface AvatarCountBadgeProps {
	count: number;
	/** Rendered avatar width in px, so the dot can hold a fixed on-screen size. */
	size: number;
}

export const AvatarCountBadge: FC<AvatarCountBadgeProps> = ({ count, size }) => {
	const theme = useTheme();
	const label = count > BADGE.MAX_COUNT ? `${BADGE.MAX_COUNT}+` : String(count);
	return (
		<g>
			<circle
				cx={BADGE_CENTER.x}
				cy={BADGE_CENTER.y}
				r={pxToArtUnits(BADGE.DIAMETER_PX / 2, size)}
				fill={BADGE.FILL}
				stroke={BADGE.RING}
				strokeWidth={pxToArtUnits(BADGE.RING_PX, size)}
			/>
			<text
				x={BADGE_CENTER.x}
				y={BADGE_CENTER.y}
				fontSize={pxToArtUnits(BADGE.FONT_PX, size)}
				fontWeight={theme.typography.fontWeightBold}
				fill={BADGE.TEXT}
				textAnchor="middle"
				dominantBaseline="central"
			>
				{label}
			</text>
		</g>
	);
};
